"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5598],{

/***/ 21971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ GridItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40865);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      col-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      row-span-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * GridItem
 */ var GridItem = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _colSpanXXS = param.colSpanXXS, colSpanXXS = _colSpanXXS === void 0 ? 1 : _colSpanXXS, colSpanXS = param.colSpanXS, colSpanSM = param.colSpanSM, colSpanMD = param.colSpanMD, colSpanLG = param.colSpanLG, colSpanXL = param.colSpanXL, colSpanXXL = param.colSpanXXL, _rowSpanXXS = param.rowSpanXXS, rowSpanXXS = _rowSpanXXS === void 0 ? 1 : _rowSpanXXS, rowSpanXS = param.rowSpanXS, rowSpanSM = param.rowSpanSM, rowSpanMD = param.rowSpanMD, rowSpanLG = param.rowSpanLG, rowSpanXL = param.rowSpanXL, rowSpanXXL = param.rowSpanXXL, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (0,common_tags__WEBPACK_IMPORTED_MODULE_2__/* .oneLine */ .f9)(_templateObject(), colSpanXXS, colSpanXS ? "xs:col-span-".concat(colSpanXS) : "", colSpanSM ? "sm:col-span-".concat(colSpanSM) : "", colSpanMD ? "md:col-span-".concat(colSpanMD) : "", colSpanLG ? "lg:col-span-".concat(colSpanLG) : "", colSpanXL ? "xl:col-span-".concat(colSpanXL) : "", colSpanXXL ? "2xl:col-span-".concat(colSpanXXL) : "", rowSpanXXS, rowSpanXS ? "xs:row-span-".concat(rowSpanXS) : "", rowSpanSM ? "sm:row-span-".concat(rowSpanSM) : "", rowSpanMD ? "md:row-span-".concat(rowSpanMD) : "", rowSpanLG ? "lg:row-span-".concat(rowSpanLG) : "", rowSpanXL ? "xl:row-span-".concat(rowSpanXL) : "", rowSpanXXL ? "2xl:row-span-".concat(rowSpanXXL) : "", className),
        children: children
    });
};


/***/ }),

/***/ 23034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(40865);
;// CONCATENATED MODULE: ./components/molecules/grid/Grid.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid grid-flow-row-dense  \n      ",
        "\n      grid-cols-",
        "\n      xs:grid-cols-",
        "\n      sm:grid-cols-",
        "\n      md:grid-cols-",
        "\n      lg:grid-cols-",
        "\n      ",
        "\n      ",
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Grid
 */ var Grid = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, style = param.style, _outline = param.outline, outline = _outline === void 0 ? true : _outline, _xxs = param.xxs, xxs = _xxs === void 0 ? 1 : _xxs, _xs = param.xs, xs = _xs === void 0 ? 2 : _xs, _sm = param.sm, sm = _sm === void 0 ? 3 : _sm, _md = param.md, md = _md === void 0 ? 4 : _md, _lg = param.lg, lg = _lg === void 0 ? 6 : _lg, xl = param.xl, xxl = param.xxl, refProp = param.refProp, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject(), outline ? "gap-px *:outline *:outline-1 *:outline-primary-200" : "", xxs, xs, sm, md, lg, xl ? "xl:grid-cols-".concat(xl) : "", xxl ? "2xl:grid-cols-".concat(xxl) : "", className),
        ref: refProp,
        style: style,
        children: children
    });
};

// EXTERNAL MODULE: ./components/molecules/grid/GridItem.tsx
var GridItem = __webpack_require__(21971);
;// CONCATENATED MODULE: ./components/molecules/grid/index.ts


Grid.Item = GridItem/* GridItem */.P;
GridItem/* GridItem.displayName */.P.displayName = "Grid.Item";
/* harmony default export */ var grid = (Grid);


/***/ }),

/***/ 85598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(40587);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59203);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7842);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23034);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(25634);
/* harmony import */ var _lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57797);
/* harmony import */ var _lib_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59197);
/* harmony import */ var _lib_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24460);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20457);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2671);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82702);












var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 30650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30650)
            ];
        }
    },
    ssr: true
});
var Video = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3191), __webpack_require__.e(4111), __webpack_require__.e(6785)]).then(__webpack_require__.bind(__webpack_require__, 66785));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66785)
            ];
        }
    },
    ssr: true
});
var ExperienciasFlexible = function(param) {
    var bloque = param.bloque, id = param.id;
    var cart = (0,_lib_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCart */ .j)().cart;
    var thisRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), maxRows = ref[0], setMaxRows = ref[1];
    var entry = (0,_lib_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useIntersectionObserver */ .S)(thisRef, {
        freezeOnceVisible: true
    });
    var isVisible = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var rows = 0;
        bloque.columns.forEach(function(element) {
            return rows = rows < element.rows.length ? element.rows.length : rows;
        });
        setMaxRows(rows);
    }, [
        bloque
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isVisible) {
            bloque.columns.forEach(function(column) {
                return column.rows.forEach(function(row) {
                    return (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__/* .gtmPush */ .De)({
                        event: "view_promotion",
                        creative_name: row.gtmCreativeName,
                        creative_slot: row.gtmCreativeSlot,
                        promotion_id: row.gtmCreativePromotionId,
                        promotion_name: row.gtmCreativePromotionName,
                        items: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__/* .normalizeCartItems */ .D)(cart)
                    });
                });
            });
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isVisible
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openModal = ref1[0], setOpenModal = ref1[1];
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        id: id,
        wrapper: true,
        padding: "px-0 \n      ".concat(bloque.mobilePadding === "top" ? "pt-4" : "", "\n      ").concat(bloque.mobilePadding === "bottom" ? "pb-4" : "", "\n      ").concat(bloque.mobilePadding === "both" ? "py-4" : "", "\n      md:py-8"),
        as: "section",
        ref: thisRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            xs: 1,
            sm: bloque.columns.length,
            md: bloque.columns.length,
            lg: bloque.columns.length,
            outline: false,
            className: "md:!grid-flow-col"
        }, bloque.height ? {
            style: {
                minHeight: bloque.height
            }
        } : {}), {
            children: bloque.columns.map(function(column) {
                return column.rows.map(function(row, index) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, column.rows.length === 1 ? {
                                rowSpanXS: maxRows
                            } : {}), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_12__/* .containerTransformer */ .a)({
                                    imagenBase: row === null || row === void 0 ? void 0 : row.imagenBase,
                                    overlay: row === null || row === void 0 ? void 0 : row.overlay,
                                    srcset: (ref2 = row === null || row === void 0 ? void 0 : row.srcset) !== null && ref2 !== void 0 ? ref2 : [],
                                    justify: row === null || row === void 0 ? void 0 : row.justify,
                                    align: row === null || row === void 0 ? void 0 : row.align
                                })), {
                                    style: {
                                        minHeight: row.minHeight,
                                        backgroundColor: row === null || row === void 0 ? void 0 : row.colorDeFondo
                                    },
                                    padding: "px-8 py-10 md:px-11",
                                    className: "h-full\n                ".concat(row.textColor === "light" && "text-typo-alternative"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex ".concat(row === null || row === void 0 ? void 0 : row.imageLocation, " gap-5"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_atoms__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (0,_lib_graphql_transformers__WEBPACK_IMPORTED_MODULE_12__/* .containerTransformer */ .a)({
                                                align: row === null || row === void 0 ? void 0 : row.align,
                                                textAlign: row === null || row === void 0 ? void 0 : row.textAlign,
                                                justify: row === null || row === void 0 ? void 0 : row.justify
                                            })), {
                                                padding: "p-0",
                                                children: [
                                                    (row === null || row === void 0 ? void 0 : row.pretitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "u-actions u-actions--link mb-2",
                                                        children: row.pretitle
                                                    }),
                                                    (row === null || row === void 0 ? void 0 : row.titulo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "u-headline ".concat(column.rows.length === 1 ? "u-headline--h1" : "u-headline--h2", " mb-6 block max-w-[400px]"),
                                                        dangerouslySetInnerHTML: {
                                                            __html: row.titulo
                                                        }
                                                    }),
                                                    (row === null || row === void 0 ? void 0 : row.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "u-subtitle u-subtitle--m mb-6 max-w-[300px]",
                                                        children: row.description
                                                    }),
                                                    row.buttonType === "link" && ((ref = row.linkButton.link) === null || ref === void 0 ? void 0 : ref.url) && row.linkButton.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                        href: (0,_lib_utils__WEBPACK_IMPORTED_MODULE_14__/* .removeBaseURL */ .t7)((ref1 = row.linkButton.link) === null || ref1 === void 0 ? void 0 : ref1.url) || "/",
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            as: "a",
                                                            negative: row.linkButton.negativo,
                                                            variant: row.linkButton.style,
                                                            onClick: function() {
                                                                var field = row;
                                                                (0,_lib_utils__WEBPACK_IMPORTED_MODULE_6__/* .gtmPush */ .De)({
                                                                    event: "select_promotion",
                                                                    creative_name: field.gtmCreativeName,
                                                                    creative_slot: field.gtmCreativeSlot,
                                                                    promotion_id: field.gtmCreativePromotionId,
                                                                    promotion_name: field.gtmCreativePromotionName,
                                                                    items: []
                                                                });
                                                            },
                                                            children: row.linkButton.label
                                                        })
                                                    }),
                                                    row.buttonType === "video" && row.videoButton.video.videoid && (row.videoButton.contentType === "label" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        size: row.videoButton.size,
                                                        variant: row.videoButton.variant,
                                                        onClick: function() {
                                                            setOpenModal(true);
                                                        },
                                                        children: row.videoButton.label
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "relative",
                                                        onClick: function() {
                                                            setOpenModal(true);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_16__/* .Play */ .s, {
                                                            color: row.videoButton.variant === "primary" ? "#262626" : row.videoButton.variant === "secondary" ? "#FFFFFF" : "#F68217",
                                                            width: 64,
                                                            height: 64,
                                                            className: "cursor-pointer"
                                                        })
                                                    })),
                                                    row.buttonType === "newsletter" && row.newsletterButton.label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_molecules__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        size: row.newsletterButton.size,
                                                        variant: row.newsletterButton.style,
                                                        negative: row.newsletterButton.negativo,
                                                        className: "button-lightbox-popin",
                                                        children: row.newsletterButton.label
                                                    })
                                                ]
                                            })),
                                            row.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "self-center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: row.image.sourceUrl,
                                                    alt: row.image.altText,
                                                    width: row.image.mediaDetails.width,
                                                    height: row.image.mediaDetails.height
                                                })
                                            })
                                        ]
                                    })
                                }))
                            }), index),
                            row.buttonType === "video" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                                open: openModal,
                                setOpen: setOpenModal,
                                noMaxWidthDesktop: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "sm:min-w-[360px] lg:min-w-[640px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Video, {
                                        type: row.videoButton.video.type,
                                        videoId: row.videoButton.video.videoid
                                    })
                                })
                            }, "modal_".concat(column, "_").concat(index))
                        ]
                    }, index);
                });
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ExperienciasFlexible);
ExperienciasFlexible.displayName = "FlexibleExperiencias";


/***/ }),

/***/ 57797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ containerTransformer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var containerTransformer = function(container) {
    var ref, ref1, ref2, ref3;
    var baseImage = container === null || container === void 0 ? void 0 : (ref = container.imagenBase) === null || ref === void 0 ? void 0 : ref.sourceUrl;
    var ref4;
    var layoutImages = (ref4 = container === null || container === void 0 ? void 0 : (ref1 = container.srcset) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
        return Boolean(i.imagen);
    }).map(function(image) {
        var ref;
        return {
            media: image.anchura,
            src: (ref = image.imagen) === null || ref === void 0 ? void 0 : ref.sourceUrl,
            width: image.imagen.mediaDetails.width,
            height: image.imagen.mediaDetails.height
        };
    })) !== null && ref4 !== void 0 ? ref4 : [];
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, (container === null || container === void 0 ? void 0 : container.imagenBase) ? (container === null || container === void 0 ? void 0 : (ref2 = container.imagenBase) === null || ref2 === void 0 ? void 0 : ref2.sourceUrl) ? {
        backgroundImage: {
            src: baseImage,
            srcset: layoutImages,
            alt: container === null || container === void 0 ? void 0 : (ref3 = container.imagenBase) === null || ref3 === void 0 ? void 0 : ref3.altText,
            height: container.imagenBase.mediaDetails.height,
            width: container.imagenBase.mediaDetails.width
        }
    } : {
        backgroundImage: baseImage
    } : {}, (container === null || container === void 0 ? void 0 : container.colorDeFondo) ? {
        style: {
            backgroundColor: container === null || container === void 0 ? void 0 : container.colorDeFondo
        }
    } : {}, (container === null || container === void 0 ? void 0 : container.overlay) ? {
        overlay: (container === null || container === void 0 ? void 0 : container.overlay) / 100
    } : {}, (container === null || container === void 0 ? void 0 : container.justify) ? {
        justify: container === null || container === void 0 ? void 0 : container.justify.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.justify : "".concat(currentValue.mediaQuery, ":").concat(currentValue.justify));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.align) ? {
        align: container === null || container === void 0 ? void 0 : container.align.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.align : "".concat(currentValue.mediaQuery, ":").concat(currentValue.align));
        }, "")
    } : {}, (container === null || container === void 0 ? void 0 : container.textAlign) ? {
        textAlign: container === null || container === void 0 ? void 0 : container.textAlign.reduce(function(previousValue, currentValue) {
            return "".concat(previousValue, " ").concat(currentValue.mediaQuery === "none" ? currentValue.textAlign : "".concat(currentValue.mediaQuery, ":").concat(currentValue.textAlign));
        }, "")
    } : {});
};


/***/ })

}]);